// Import ES6 Promise
import 'es6-promise/auto'

// Import System requirements
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
// Vuetify
import Vuetify from 'vuetify'
// VueClipboard
import VueClipboard from 'vue-clipboard2'

// Vue Analytics
import VueAnalytics from 'vue-analytics'
// Vue Read More
import ReadMore from 'vue-read-more';
// Vue Recaptcha
// import { VueReCaptcha } from 'vue-recaptcha-v3'

import {
  sync
} from 'vuex-router-sync'
import routes from './routes'
import store from './store'
import config from '@/config'
import { watchSessionExpiry } from '@/utils/sessionExpiry'
// Mask Text Field
import VueTheMask from 'vue-the-mask'
// Init facebook sdk
import {
  initFbSdk
} from './plugins/fb-sdk'

// Vue tab
import {
  Tabs,
  Tab
} from 'vue-tabs-component'
Vue.component('tabs', Tabs)
Vue.component('tab', Tab)

// For more options see below
// Vue.use(VueReCaptcha, { siteKey: '6Ld3D7cqAAAAACgNKLhUYiHW7f4oQ5DJSWKGXOOv' })

// Popup
import VueSweetalert2 from 'vue-sweetalert2'
import Loading from 'vue-loading-overlay';
// Import Helpers for filters
import {
  domain,
  count,
  prettyDate,
  pluralize,
  thousandSeprator,
  currency,
  abbr
} from './filters'
import { platformDisplayName } from './utils/platformDisplay'

import { SortableDataTable } from './directives'

// Import Views - Top level
import AppView from './components/App.vue'

// Import bootstrap and bootstrap-vue
// Do not import bootstrap from node_modules because that was v4.0 that will conflict with AdminLTE styling for v3.0
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-tabs-component/docs/resources/tabs-component.css'
import 'vue-loading-overlay/dist/vue-loading.css'
// vuetify
import 'vuetify/dist/vuetify.css'
// Excel
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)
// custom CSS
import './../static/css/custom.css'
import './../static/css/b-pagination.css'

import wysiwyg from 'vue-wysiwyg';
import 'vue-wysiwyg/dist/vueWysiwyg.css';
Vue.use(wysiwyg, {
  maxHeight: '500px'
});

// Import Install and register helper items
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)
Vue.filter('thousandSeprator', thousandSeprator)
Vue.filter('currency', currency)
Vue.filter('abbr', abbr)
Vue.filter('platformDisplayName', platformDisplayName)

// import directives
Vue.directive('sortable-data-table', SortableDataTable)

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueRouter)
Vue.use(VueSweetalert2)
Vue.use(Vuetify)
Vue.use(VueClipboard)
Vue.use(VueTheMask)
Vue.use(ReadMore)

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#A3FF12',
        secondary: '#3F3FFF',
        accent: '#1A1A1A',
        info: '#3F3FFF',
        success: '#15803D',
        warning: '#F4B740',
        error: '#D83A2E',
        anchor: '#3F3FFF',
        surface: '#F4F4F4',
        ink: '#1A1A1A',
        facebook: '#1778F2',
        instagram: '#F77737'
      }
    }
  }
})

export default vuetify
Vue.use(Loading)

// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || {
      x: 0,
      y: 0
    }
  }
})

// Google Analytics
Vue.use(VueAnalytics, {
  id: ['UA-135074880-1', 'UA-135074880-2'],
  router
})

// all Cloudinary components:
import Cloudinary from 'cloudinary-vue';
Vue.use(Cloudinary, {
  configuration: {
    cloudName: config.cldConfig.CLOUD_NAME,
    secure: true }
});

const fbOptions = {
  appId: config.FACEBOOK_APP_ID,
  version: 'v15.0'
}
initFbSdk(fbOptions).then(() => {
  console.log('facebook sdk is ready for use')
})
// Vue tab
// Warning Messages Handler
/* Unsolve Bug on Vue
Reference: https://github.com/vuetifyjs/vuetify/issues/9999
To update update later after checking this issue
*/
const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
}

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  // Check if user has logged in before
  var isLoggedIn = false
  if (router.app.$store.state.token && router.app.$store.state.token !== 'null' && router.app.$store.state.user) {
    isLoggedIn = true
  }
  /**
   * Aung
   * #NOTE
   * Check Reports route to go free Access and free authenticated
   */
  if (to.name === 'CampaignSummaryReports' || to.name === 'CampaignHtmlReport') {
    return next()
  }
  if (to.name === 'InstagramIntegrate') {
    if (isLoggedIn) {
      return next()
    } else {
      return next({
        name: 'Login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  }

  if (to.name === 'CreateClientFeedbackForm' ||
  to.name === 'CreateBrandSheetForm' ||
  to.name === 'RateCardForm' ||
  to.name === 'JoinCommunityForm' ||
  to.name === 'CreateSigningForm' ||
  to.name === 'ProfileTallyForm' ||
  to.name === 'CreatorConceptForm' ||
  to.name === 'PayoutSubmission') {
    return next()
  }

  // Check if user is already authenticated and tries to access login page, we need to redirect user back to home page
  if (config.freeAccessRoutes.includes(to.name)) {
    if (isLoggedIn) {
      next('/')
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    next({
      name: 'Login',
      query: {
        redirect: to.fullPath
      }
    })
  } else {
    // Check if user has permission to view this page
    const userRole = Number(router.app.$store.state.user.role)
    var hasPermission = false
    if (isLoggedIn) {
      hasPermission = to.matched.some(function (record) {
        return record.meta.allow && record.meta.allow.includes(userRole)
      })
    }

    if (hasPermission === false) {
      if (userRole === config.userRoles.INFLUENCER) {
        next({
          name: 'Profile'
        })
      } else if (userRole === config.userRoles.CLIENT) {
        next({
          name: 'Campaigns'
        })
      } else if (userRole === config.userRoles.MARKETING) {
        next({
          name: 'All Influencers'
        })
      } else {
        next({
          path: '/'
        })
      }
    } else {
      next()
    }
  }
})

sync(store, router)

// Check local storage to handle refreshes
if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null'
  var localUser = JSON.parse(localUserString)

  if (localUser && store.state.user !== localUser) {
    store.commit('SET_USER', localUser)
    store.commit('SET_TOKEN', window.localStorage.getItem('token'))
  }
}

watchSessionExpiry(store)

// store the global configuration file to state
store.commit('SET_GLOBAL_CONFIG', config)

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#root',
  router: router,
  vuetify,
  store: store,
  render: h => h(AppView)
})



// WEBPACK FOOTER //
// ./src/main.js